import React, { useState, useEffect } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useNavigate } from 'react-router-dom';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { IoSearch } from 'react-icons/io5';
import { AiOutlinePrinter } from "react-icons/ai";
import "../pagination/pagination.css"
import { IoAddSharp } from "react-icons/io5";
import Pagination from '../pagination/pagination';
import { RiRefreshLine } from "react-icons/ri";
import LeaseApiService from '../../services/apiService';
import DatePicker from "react-datepicker";
import WindowedSelect from 'react-windowed-select';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { toast } from 'react-toastify';
const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const MiscellaneousReceiptListing = () => {
    const [rowData, setRowData] = useState([])
    const [unitList, setUnitList] = useState([])
    const [loading, setLoading] = useState(true)
    const [pageSize, setPageSize] = useState(20)
    const [periodTo, setPeriodTo] = useState("")
    const [leaseList, setLeaseList] = useState([])
    const [pagination, setPagination] = useState()
    const [proprtyList, setProperty] = useState([])
    const [FilterTab, setFilterTab] = useState(true)
    const [periodFrom, setPeriodFrom] = useState("")
    const [selectedRow, setSelectedRow] = useState(null)
    const [contextMenu, setContextMenu] = useState(null)
    const apiService = new LeaseApiService();
    let navigate = useNavigate();

    const [formData, setFormData] = useState({
        receipt: "",
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        leaseNo: [{ label: 'Select Lease No', value: '' }],
    })

    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 50, pinned: 'left' },
        { headerName: 'Voucher No', field: 'voucherNo', filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
        {
            headerName: "Posting Date", field: "postingDate", filter: true, floatingfilter: true,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        { headerName: 'Lease No', field: 'leaseNo', filter: true, floatingfilter: true, suppressMovable: true, width: 200 },
        { headerName: 'Property', field: 'propertyName', filter: true, floatingfilter: true, suppressMovable: true, width: 200 },
        { headerName: 'Unit No', field: 'unitNo', filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
        { headerName: 'Tenant', field: 'tenantName', filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
        { headerName: 'Amount', field: 'amount', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
        { headerName: 'VAT', field: 'vat', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
        { headerName: 'Total', field: 'total', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
        { headerName: 'Received', field: 'received', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
        { headerName: 'CN Amount', field: 'cnAmount', filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
    ]

    useEffect(() => {
        const today = new Date();
        const nextMonth = new Date(today);
        nextMonth.setMonth(today.getMonth() + 1);
        nextMonth.setDate(nextMonth.getDate() + 1);
        const formattedToday = today.toISOString().split("T")[0];
        const formattedNextYear = nextMonth.toISOString().split("T")[0];

        setPeriodFrom(formattedToday);
        setPeriodTo(formattedNextYear);
        fetchDropdownData();
        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);

    }, [])
    useEffect(() => {
        getItems();
    }, [])
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LGISerPropertyName,LGISerLeaseNo');
            const res = await apiService.getApiParamater('GET_GENERAL_MULTI', `?${params.toString()}`);
            setProperty(res?.data?.dropdowns?.LGISerPropertyName)
            setLeaseList(res?.data?.dropdowns?.LGISerLeaseNo)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handlePrint = (rowData) => {
        if (selectedRow) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase")
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "RecordId", value: "" },
                    { name: "LeaseNo", value: selectedRow?.leaseNo },
                    { name: "ReceiptNo", value: selectedRow?.receiptNo },
                    { name: "reportName", value: 'LEASEBULKRPT' },
                ];
                
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {

            const today = new Date();
            const nextMonth = new Date(today);
            nextMonth.setMonth(today.getMonth() + 1);
            nextMonth.setDate(nextMonth.getDate() + 1);
            const formattedToday = today.toISOString().split("T")[0];
            const formattedNextYear = nextMonth.toISOString().split("T")[0];
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('PropertyNo', formData?.Proprty?.value?.value || 'All');
            params.append('UnitNo', formData?.unitNo?.label || 'All');
            params.append('LeaseNo', formData?.leaseNo?.label || 'All');
            params.append('FromDate', periodFrom || formattedToday);
            params.append('ToDate', periodTo || formattedNextYear);
            const res = await apiService.getApiParamater('GET_GENERAL_LIST', `?${params.toString()}`);
            if (res?.data?.message === "Record not found") {
                toast.error("Record not found")
            }
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const handleSearch = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('PageNo', 1);
            params.append('PageSize', pageSize || 20);
            params.append('PropertyNo', formData?.Proprty?.value?.value || 'All');
            params.append('UnitNo', formData?.unitNo?.label || 'All');
            params.append('LeaseNo', formData?.leaseNo?.label || 'All');
            params.append('FromDate', periodFrom);
            params.append('ToDate', periodTo);

            const res = await apiService.getApiParamater('GET_GENERAL_LIST', `?${params.toString()}`);
            setRowData(res?.data?.result || []);

            if (res?.data?.message === "Record not found") {
                toast.error("Record not found")
            }
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const onSelectionChanged = async (event) => {
        const selectedRows = event.api.getSelectedRows();
        setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
    }
    const handlenew = () => {
        navigate('/Property/Management/Lease/GeneralInvoice')
    }
    const handleClearFilters = () => {
        setFormData({
            receipt: "",
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            leaseNo: [{ label: 'Select Lease No', value: '' }],
        });
    }
    const handlePropertyChange = async (selectedOption) => {
        const params = new URLSearchParams();
        params.append('DropdownFor', 'LGISerUnitsByPropId');
        params.append('CascadValue', selectedOption?.value?.value);
        const res = await apiService.getApiParamater('GET_GENERAL_CASCAD', `?${params.toString()}`);
        setUnitList(res?.data?.items || []);
        setFormData({
            ...formData,
            Proprty: selectedOption,
            unitNo: [{ label: 'select Unit No', value: '' }]
        });
    }
    const handleUitNo = (selectedOption) => {
        setFormData({ ...formData, unitNo: selectedOption });
    }
    const handelLeaseNo = (selectedOption) => {
        setFormData({ ...formData, leaseNo: selectedOption });
    }
    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const handlePeriodFromChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodFrom(formattedDate);
    }
    const handlePeriodToChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodTo(formattedDate);
    }
    const handleBackClick = () => {
        window.history.back();
    }
    return (
        <div className='p-3 '>
            <div className="cost-center-section">
                <div className="d-flex  cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='h6 pt-1'>Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="row">
                            <div className="col-10 mt-3" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: '15px' }}>
                                <div className="d-flex">
                                    <label htmlFor="dateFrom" className="form-label pt-1 start">From</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={periodFrom}
                                        onChange={(date) => handlePeriodFromChange({ name: 'leaseDate', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100"
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="property" className="form-label pt-1 start">Property</label>
                                    <WindowedSelect
                                        className="w-100  p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                color: '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',

                                                    color: '#000',
                                                },
                                            }),
                                        }}
                                        value={formData.Proprty}
                                        onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                        options={proprtyList?.map((rec) => ({ value: rec, label: rec?.text }))}

                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="unit" className="form-label pt-1 start">
                                        Unit
                                    </label>
                                    <WindowedSelect
                                        className="w-100  p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                color: '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',

                                                    color: '#000',
                                                },
                                            }),
                                        }}

                                        value={formData.unitNo}
                                        onChange={(selectedOption) => handleUitNo(selectedOption)}
                                        options={unitList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="dateTo" className="form-label pt-1 start">To</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={periodTo}
                                        onChange={(date) => handlePeriodToChange({ name: 'toDate', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100"
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="leaseNo" className="form-label pt-1 start">
                                        Lease No
                                    </label>
                                    <WindowedSelect
                                        className="w-100  p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                color: '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',

                                                    color: '#000',
                                                },
                                            }),
                                        }}

                                        value={formData.leaseNo}
                                        onChange={(selectedOption) => handelLeaseNo(selectedOption)}
                                        options={leaseList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                    />
                                </div>
                                <div className="d-flex align-items-center">
                                    <label className='start w-25'></label>
                                    <input type="file" className="form-control" />
                                </div>
                            </div>
                            <div className="col-2 center">
                                <div className="">
                                    <div className="mainbtnGry gap-2" onClick={handleSearch}>
                                        <IoSearch color="#fff" className="center mt-1 mx-2" />
                                        <div className="center">Search</div>
                                    </div>
                                    <div className="mainbtnSecondary gap-2 my-2 " onClick={handleBackClick}>
                                        <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
                                        <div className="center">Back</div>
                                    </div>
                                    <div className="mainbtnRed gap-2" onClick={handleClearFilters}>
                                        <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                                        <div className="center">Reset</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='border-box2 p-4'>
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className='d-flex justify-contant-between '>
                            <h5 className='col mainInvHead'>Miscellaneous Receipt List</h5>
                            <div className='d-flex justify-content-end gap-1'>
                                <div
                                    onClick={handlePrint}
                                    className={`mainbtnRed flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                                    style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                                >
                                    <AiOutlinePrinter color='#fff' className='center mt-1 ' />
                                    <div className='center'>Print</div>
                                </div>
                                {/* {permissions?.canAdd === true ? */}
                                <div className='col center'>
                                    <button className='mainbtn ' type="submit" onClick={() => handlenew()}>
                                        <IoAddSharp color='#fff' className='center mt-1' /> <div>Add</div>
                                    </button>
                                </div>
                                {/* : '' */}
                                {/* } */}
                            </div>
                        </div>
                        <div className='gridshad  mt-3'>
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: '#F0EDF5' };
                                        } else {
                                            return { background: '#fff' };
                                        }
                                    }}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                    onSelectionChanged={onSelectionChanged}
                                />
                            </div>
                            <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                        </div>
                    </>
                )}
            </div>
        </div>

    );
};
export default MiscellaneousReceiptListing;